import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const locationTypes = {
    location: "location",
    rack: "rack",
    slot: "slot",
    zone: "zone",
}

export const targetTypes = {
    location: "location",
    rack: "rack",
    slot: "slot",
    zone: "zone",
}

export function useLocations({
    locationType: _locationType, 
    targetType: _targetType
}) {

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [ locationType, setLocationType ] = useState(_locationType)
    const [ targetType, setTargetType ] = useState(_targetType)

    const [ isLoading, setIsLoading ] = useState(false)

    const endpoint = "locations";
    const endpoint2 = "location";
    // const endpoint3 = "location/location";

    const list = async (props) => {

        setIsLoading(true);

        try{

            const {
                locationType: overrideLocationType,
                parentId
            } = props

            let url = getListsUrl(`${endpoint}/${locationType}`, props);

            if(overrideLocationType){
                url = getListsUrl(`${endpoint}/${overrideLocationType}`, props);
            }

            if(
                overrideLocationType === locationTypes.rack ||
                overrideLocationType === locationTypes.slot ||
                overrideLocationType === locationTypes.zone
            ){
                url = getListsUrl(`${endpoint}/${overrideLocationType}/${parentId}`, props);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });
            
            setIsLoading(false);

            return response;

        }catch(error){

            setIsLoading(false);
            throw error;

        }
        
    }

    const create = async ({ data }) => {

        setIsLoading(true)

        try{

            const url = endpoint2;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }
            
            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });
            
            setIsLoading(false);

            return response;

        }catch(error){

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data }) => {

        setIsLoading(true)

        try{

            const url = `${endpoint2}/${id}`

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }
            
            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });
            
            setIsLoading(false);

            return response;

        }catch(error){

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids, targetType: overrideTargetType }) => {

        setIsLoading(true);

        if(ids.length <= 0){
            throw getError(false, `Please select at least (1) items`)
        }

        try{

            const url = `${endpoint}/delete`

            let postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            if(overrideTargetType) postData.scope.target = overrideTargetType
            
            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        }catch(error){

            setIsLoading(false);
            throw error;

        }

    } 


    const get = async ({ id, dataTypesArray = [] }) => {

        setIsLoading(true);

        try{

            const url = getUrlWithDataTypes(`${endpoint2}/${locationType}/${id}`, dataTypesArray)

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        }catch(error){

            setIsLoading(false);
            throw error;

        }

    } 
    
    return { 
        isLoading,
        filterOperatorTypes,
        list,
        get, 
        create,
        update, 
        remove 
    }
}